import { request } from '../request';

/**
 * 获取设计师主页信息
 * @param {Object} params params
 */
export function fetchDesignerHomePageInfo(params) {
  return request.post('/designer/getHomepageInfo', params);
}

/**
 * 获取设计师主页信息-方案列表
 * @param {Object} params params
 */
export function fetchDesignerScheme(params) {
  return request.post('/designer/listByPageHomepageScheme', params);
}

/**
 * 关注设计师
 * @param {Object} params params
 */
export function queryDesignerFollow(params) {
  return request.post('/designer/follow', params);
}

/**
 * 获取设计师个人信息
 */
export function fetchUserInfo() {
  return request.get('/designer/getUserInfo');
}

/**
 * 获取我的家信息
 * @param {*} params { homepageId, userName}
 * @returns {}
 */
export function fetchMyHomeInfo(params) {
  return request.post('/myHome/getMyHomeInfo', params);
}

/**
 * 更新我的家可见权限
 */
export function updateVisiblePrivilege(params) {
  return request.post('/myHome/updateVisiblePrivilege', params);
}

/**
 * 根据homepageId获取用户roleId: 未登录
 */
export function fetchUserRole({ homepageId }) {
  return request.post('/designer/getUserRole', { homepageId });
}

/**
 * 根据登录cookie获取用户角色:
 */
export function fetchUserRoleByCK() {
  return request.post('/designer/getUserRole', {});
}

export function updateHomeInfoViewTrack(params) {
  return request.post('/buryPoint/homepageView', params);
}
